<template>
    <div>
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item">Tesorería</li>
                <li class="breadcrumb-item active" aria-current="page">Retiros realizados a Inversionistas</li>
            </ol>
        </nav>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-header">Retiros a inversionistas</div>
                        <div class="card-body">

                            <withdrawals-finder
                                @onSubmit="search"
                                label="Nombre o Razón social, RFC, email, IID, UID"></withdrawals-finder>

                            <div class="withdrawals-investor">
                                <vs-table class="table table-sm" :data="withdrawals">
                                    <template slot="thead" class="thead-dark">
                                      <vs-th>TRX</vs-th>
                                      <vs-th>Procesador</vs-th>
                                      <vs-th>Trans. ID</vs-th>
                                      <vs-th>UID</vs-th>
                                      <vs-th>IID</vs-th>
                                      <vs-th>Nombre o Razón</vs-th>
                                      <vs-th>Concepto</vs-th>
                                      <vs-th>Monto</vs-th>
                                      <vs-th>F. Solicitud</vs-th>
                                      <vs-th>F. Confirmación</vs-th>
                                    </template>
                                    <template slot-scope="{data}">
                                      <vs-tr v-for="wd in data" v-bind:key="wd.id">
                                          <vs-td>{{wd.trx_type}}</vs-td>
                                          <vs-td>{{wd.payment_processor}}</vs-td>
                                          <vs-td>{{wd.trx_id}}</vs-td>
                                          <vs-td>{{wd.user_id}}</vs-td>
                                          <vs-td>{{wd.investor_id}}</vs-td>
                                          <vs-td width="200px">{{wd.fiscal_name}}</vs-td>
                                          <vs-td width="300px">{{wd.concept}}</vs-td>
                                          <vs-td>{{wd.amount|currency}}</vs-td>
                                          <vs-td>{{wd.created_at|humanizeDate}}</vs-td>
                                          <vs-td>{{wd.trx_confirmation_date|humanizeDate}}</vs-td>
                                      </vs-tr>
                                    </template>
                                </vs-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {fromNowDate, humanizeDate} from "@/filters/momentTzConvert";

let WithdrawalsFinder = require('./withdrawals-finder').default;
import { InvestorWithdrawals } from "../../../bl/withdrawals/InvestorWithdrawals";
import { AxiosErrorException } from '../functions/axiosErrorException';

export default {
    components: {
        'withdrawals-finder': WithdrawalsFinder
    },
    data() {
        return {
            withdrawals: []
        }
    },
    filters: {
        humanizeDate,
    },
    async mounted() {
        try {
            this.getWithdrawals();
        } catch(err) {
            swal('Ups!', AxiosErrorException(err), 'error')
        }
    },
    methods: {
        fromNowDate,
        search(e) {
            try {
                this.getWithdrawals(e);
            } catch(err) {
                swal('Ups!', AxiosErrorException(err), 'error')
            }
        },
        async getWithdrawals(filters) {
            let wd = new InvestorWithdrawals();
            let res = await wd.get(filters)
            this.withdrawals = res.data;
        }
    }
}
</script>
<style scoped>
tbody.collapse {
    display: none;
}
</style>
